<template>
  <section class="form-section">
    <h2 class="section-title">Personal Information</h2>
    <div class="form-grid">
      <div class="form-group">
        <label class="form-label" for="fullName">Full Name</label>
        <input 
          type="text" 
          id="fullName" 
          :value="personalInfo.fullName"
          @input="updatePersonalInfo('fullName', $event.target.value)"
          :class="['form-input', { 'field-needs-review': highlightedFields.includes('fullName') }]"
          placeholder="Enter your full name"
          required
        />
        <div v-if="highlightedFields.includes('fullName')" class="review-badge mt-1">
          <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          Missing or unclear data - please verify
        </div>
      </div>
      <div class="form-group">
        <label class="form-label" for="email">Email</label>
        <input 
          type="email" 
          id="email" 
          :value="personalInfo.email"
          @input="updatePersonalInfo('email', $event.target.value)"
          :class="['form-input', { 'field-needs-review': highlightedFields.includes('email') }]"
          placeholder="your.email@example.com"
          required
        />
        <div v-if="highlightedFields.includes('email')" class="review-badge mt-1">
          <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          Missing or unclear data - please verify
        </div>
      </div>
      <div class="form-group">
        <label class="form-label" for="phone">Phone</label>
        <input 
          type="tel" 
          id="phone" 
          :value="personalInfo.phone"
          @input="updatePersonalInfo('phone', $event.target.value)"
          :class="['form-input', { 'field-needs-review': highlightedFields.includes('phone') }]"
          placeholder="+1 (555) 123-4567"
        />
        <div v-if="highlightedFields.includes('phone')" class="review-badge mt-1">
          <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          Missing or unclear data - please verify
        </div>
      </div>
      <div class="form-group">
        <label class="form-label" for="location">Location</label>
        <input 
          type="text" 
          id="location" 
          :value="personalInfo.location"
          @input="updatePersonalInfo('location', $event.target.value)"
          :class="['form-input', { 'field-needs-review': highlightedFields.includes('location') }]"
          placeholder="City, Country"
        />
        <div v-if="highlightedFields.includes('location')" class="review-badge mt-1">
          <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          Missing or unclear data - please verify
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PersonalInfoForm',
  props: {
    personalInfo: {
      type: Object,
      required: true,
      default: () => ({
        fullName: '',
        email: '',
        phone: '',
        location: ''
      })
    },
    highlightedFields: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:personalInfo', 'field-changed'],
  methods: {
    updatePersonalInfo(field, value) {
      const updatedInfo = { ...this.personalInfo, [field]: value }
      this.$emit('update:personalInfo', updatedInfo)
      this.$emit('field-changed')
    }
  }
}
</script>

<style scoped>
/* Field Highlighting Styles */
.field-needs-review {
  @apply border-2 border-red-500 dark:border-red-400 bg-red-50 dark:bg-red-900/20;
}

.field-needs-review:focus {
  @apply border-red-600 dark:border-red-500 ring-2 ring-red-200 dark:ring-red-800;
}

.review-badge {
  @apply inline-flex items-center text-xs font-medium text-red-600;
}
</style> 